import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import Select from 'react-select';

import { Form } from 'react-bootstrap';
import AwpSpinner from '@components/Common/AwpSpinner';
import { currentProgramId, selectAllPrograms } from '@stores/avalancheDashboardViewPageSlice';
import { STATE_STATUS } from '@awp/constants';
import { isValueEmpty } from '@awp/helpers/utilsReact';

//Provide a list of geographic EET areas(regions) in dropdown
// Use own reducer only.
//see  usage at ..\components\dashboards\PageFilters.js

const AvalancheProgramDropdown = ({ ...props }) => {
  const regionStatus = useSelector((state) => state.avalancheDashboardViewPage.programStatus);
  const loading = useSelector((state) => state.avalancheDashboardViewPage.status);
  const allRegions = useSelector(selectAllPrograms);
  const selectedRegion = useSelector(currentProgramId);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState(null);
  const AreaChanged = props.AreaChanged;

  useEffect(() => {
    const foundRG = allRegions.find((rg) => rg.Id == selectedRegion);
    if (!foundRG) {
      setSelectedValue(null);
    } else {
      setSelectedValue({
        value: foundRG.Id,
        label: foundRG.Code === 'All' ? 'All' : foundRG.Code + ' - ' + foundRG.Name,
      });
    }
  }, [selectedRegion]);

  const LoadingIndicator = () => {
    return (
      <div className="legend__loading">
        <AwpSpinner />
      </div>
    );
  };

  function handleChange(selOption) {
    dispatch(AreaChanged(selOption.value));
  }

  return (
    <div>
      <Form.Label>
        <b>{isValueEmpty(props.title) ? 'Program' : props.title}</b>
      </Form.Label>
      <Select
        options={allRegions.map((rg) => {
          return { value: rg.Id, label: rg.Code === 'All' ? 'All' : rg.Code + ' - ' + rg.Name };
        })}
        styles={props.style}
        setState={setSelectedValue}
        value={selectedValue}
        placeholder={'Select program'}
        onChange={handleChange}
        isDisabled={loading == STATE_STATUS.LOADING}
        isLoading={loading == STATE_STATUS.LOADING || regionStatus == STATE_STATUS.LOADING}
        components={{ LoadingIndicator }}
      />
    </div>
  );
};

AvalancheProgramDropdown.propTypes = {
  AreaChanged: PropTypes.func,
};

export default AvalancheProgramDropdown;
